import _ from 'lodash'
import { FTProcess } from '@/models/FTProcess';
import { initProcess, ProcessConfig, ConversionResults, ParsedVariables, weightToPieces } from './index'
import { ConversionDetails } from '@/models/ConversionDetails';
import { FTProcessRow } from '@/models/FTProcessRow';

export function loadConfig({ processRow }: ParsedVariables): ProcessConfig {
  return {
    inputs: {
      goods: [
        {
          goodsType: '',
          goodsFilter: {
            form: ['roll']
          },
          multiple: true,
          addMultipleButtonText: 'add more input goods',
          params: [
            {
              name: 'Width',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.width', ''),
              unit: 'mm',
              disabled: true
            },
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            }
          ]
        }
      ]
    },
    outputs: {
      type: 'multiple',
      hideRemoveOutputIcon: true,
      enableMultipleIf: false,
      arguments: [
        {
          name: 'Width',
          type: 'label',
          value: _.get(processRow, 'goodsObject.dimensions.width', ''),
          unit: 'mm',
          disabled: true
        },
        {
          name: 'Length',
          type: 'dimension',
          value: 'length',
          unit: 'mm',
          disabled: false
        },
        {
          name: 'Output Quantity',
          type: 'label',
          value: _.get(processRow, 'quantity', ''),
          unit: 'kg',
          disabled: true
        }
      ]
    },
    tableHeaders: [
      {
        text: 'Nominal Speed',
        value: 'nominalSpeed'
      },
      {
        text: 'Piece(s) per stroke',
        value: 'pcsPerStroke'
      },
      {
        text: 'Planned Hours(s)',
        value: 'plannedHours'
      },
      {
        text: 'No of Pieces',
        value: 'numberOfPieces'
      },
      {
        text: 'Expected Output Waste',
        value: 'wastePercentage'
      },
      {
        text: 'Expected Output Waste Weight',
        value: 'waste'
      },
      {
        text: 'Expected Output Net Weight',
        value: 'netWeight'
      }
    ]
  }
}

export function convert(process: FTProcess) : ConversionResults {
  const conversionResult : ConversionResults = {
    inputs: [],
    outputs: [],
    details: new ConversionDetails(),
  };
  
  initProcess(process);

  process.machineDetail.pcsPerStroke = process.inputs.length;
  if (process.outputs.length < process.inputs.length) {
    process.addOutput();
  }
  if (process.outputs.length > process.inputs.length) {
    process.outputs[process.outputs.length - 1].remove();
  }
  process.updateConfig();

  conversionResult.outputs = process.outputs;
  
  _.map(process.inputs, (processInputRow: FTProcessRow, processInputIndex: number) => {
    const outputFTProcessRow = process.outputs[processInputIndex];
    if(processInputRow.goodsObject) {
      outputFTProcessRow.goodsObject.copyFrom(processInputRow.goodsObject);      
    }
    outputFTProcessRow.goodsObject.form = 'sheet';
    outputFTProcessRow.quantity = processInputRow.quantity;
    if (outputFTProcessRow.dimensions && outputFTProcessRow.dimensions.length && outputFTProcessRow.goodsObject.dimensions) {
      outputFTProcessRow.goodsObject.dimensions.length = outputFTProcessRow.dimensions.length;
      outputFTProcessRow.goodsObject.totalLength = (outputFTProcessRow.quantity * Math.pow(10, 6)) / (outputFTProcessRow.goodsObject.density * outputFTProcessRow.goodsObject.dimensions.width)
      const value = weightToPieces(outputFTProcessRow.quantity, outputFTProcessRow.goodsObject.density, outputFTProcessRow.goodsObject.dimensions.width * outputFTProcessRow.dimensions.length) / outputFTProcessRow.quantity;
      outputFTProcessRow.goodsObject.setPerKgRatio('plA', value);
      outputFTProcessRow.goodsObject.unitWeight = (outputFTProcessRow.goodsObject.density * (outputFTProcessRow.dimensions.length / 1000) * (outputFTProcessRow.goodsObject.dimensions.width / 1000)) / 1000;
    }
  })
  
  let outputQuantity = 0;
  _.each(process.outputs, outputFTProcessRow => {
    outputQuantity += outputFTProcessRow.quantity;
  });
  
  conversionResult.details.totalQuantity = outputQuantity;
  if (process.outputs[0].goodsObject.perKgRatio.plA) {
    conversionResult.details.numberOfPieces = process.outputs[0].goodsObject.perKgRatio.plA.value * process.outputs[0].quantity;
  }
  conversionResult.details.wastePercentage = 0;
  conversionResult.details.waste = 0;
  conversionResult.details.netWeight = outputQuantity;
  if (process.machineDetail.pcsPerStroke && conversionResult.outputs[0].goodsObject.unitWeight) {
      conversionResult.details.kgPerHour = 60 * conversionResult.outputs[0].goodsObject.unitWeight * process.machineDetail.mechanicalSpeed * process.machineDetail.pcsPerStroke;
      conversionResult.details.plannedHours = conversionResult.details.totalQuantity / conversionResult.details.kgPerHour;
  }
  conversionResult.details.pcsPerStroke = process.machineDetail.pcsPerStroke;

  return conversionResult;
}